import New from "csi/table/New";
import ActionControllerMixin from "csi/wizard/ActionControllerMixin";
import xml from "csi/xml";
import declare from "dojo/_base/declare";
import { REVIEWER } from "../ProofService";

export = declare([New, ActionControllerMixin], {

	/**
	 * @override
	 * Disable the finish button if no roles are selected
	 */
	disableFinish(wizard, page, index) {
		return index == 1 && !(this.m_formData.getSelectedNodes().length > 0);
	},

	/**
	 * @override
	 * Create new proof template stage
	 */
	toWriter() {
		this.inherited(arguments);
		var fd = this.m_formData;

		for (const role of fd.getSelectedNodes()) {
			this.m_writer.createNode(null, "ProofTemplateStageConfig")
				.changeAttribute("Role", xml.ATTR_REF, role.$URL)
				.changeAttribute("TaskDefinition", xml.ATTR_REF, REVIEWER)
				.attach(this.m_urlNode, "StageConfigs");
		}
	},
});
